<nav class="navbar navbar-light">
  <a class="navbar-brand p-0" routerLink="/home">
    <img src='/assets/images/logo-small.png' class="logo-image"/>
   </a></nav>
<section class="login">
<div class="container mt-2">
<div class="row justify-content-center">
  <div class=" col-10 col-sm-10 col-md-7 col-lg-5">
<div class="google-sign">
    <button class="btn btn-light" (click)="userService.GoogleAuth()">
      <i class="fab fa-google float-left"></i>
        <span> Sign in with Google</span>
    </button>
    <div class="or">
      <span class="or-span">or</span>
  </div>
</div>
<form #loginForm="ngForm" (ngSubmit)="loginForm.valid && Check(loginForm.value)" novalidate>
  <div class="alert alert-danger" role="alert" *ngIf="loginForm.valid && valid" >
   email or password is incorrect
  </div>
    <div class="mb-3">
      <label for="exampleInputEmail1" class="form-label">Email address</label>
      <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" (ngModel)="email" name="email" required 
      #email="ngModel" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+$" >
      <em class="error" *ngIf="loginForm.submitted && email.errors?.required || email.errors?.required && email.dirty">Please enter your Email</em>
      <em class="error" *ngIf="email.errors?.pattern">please enter a valid Email</em>

    </div>
    <div class="mb-3">
      <label for="exampleInputPassword1" class="form-label">Password</label>
      <input type="password" class="form-control" id="exampleInputPassword1" (ngModel)="password" name="password" required>
      <em class="error"  *ngIf="loginForm.submitted && loginForm.controls.password?.invalid || loginForm.controls.password?.invalid && loginForm.controls.password?.dirty">Your password must contain between 4 and 60 characters.</em>
    </div>
    <div class="mb-3 form-check">
      <input type="checkbox" class="form-check-input" id="exampleCheck1">
      <label class="form-check-label" for="exampleCheck1">Check me out</label>
    </div>
    <button type="submit" class="home-button">Submit</button>
    <a routerLink="/create" class="login-link"> Don't have account? register Now</a>
  </form>
</div>
</div>
</div>
</section>